import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useProjectCohortsNavigation } from '@verantos-dev/data-access-cohorts';

import { CohortBuilderLoadingTemplate } from '../components/CohortBuilderLoadingTemplate/CohortBuilderLoadingTemplate';

export const CohortVersionLoadingPage = () => {
  const navigate = useNavigate();
  const { cohortVersionId, latestCohortVersionId, navigateToPath } = useProjectCohortsNavigation();

  // Redirect to cohort builder page if cohort versions are not loaded in 5 seconds
  useEffect(() => {
    if (cohortVersionId) {
      navigate(navigateToPath);
    }
    if (latestCohortVersionId) {
      navigate(navigateToPath);
    }
    const timeoutId = setTimeout(() => {
      if (!cohortVersionId && !latestCohortVersionId) {
        navigate(navigateToPath);
      }
    }, 5000); // 5 seconds timeout

    return () => clearTimeout(timeoutId);
  }, [cohortVersionId, latestCohortVersionId, navigate, navigateToPath]);

  return <CohortBuilderLoadingTemplate />;
};
